export default __webpack_public_path__ + "static/media/remote-video-up.57423c2d.png";